import Container from "hardcover-ui/components/Container";
import UserByline from "components/users/UserByline";
import OwnerReadingJournalControls from "features/ReadingJournal/components/OwnerReadingJournalControls/OwnerReadingJournalControls";
import Callout from "hardcover-ui/components/Callout";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { usePage } from "@inertiajs/react";
import { BookJournalShowProps } from "./show.props";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import ReadingJournals from "features/ReadingJournal/components/ReadingJournals/ReadingJournals";
import BookLayout from "features/books/layouts/BookLayout/BookLayout";

export type ReadingJournalSearchParamsType = {
  page?: string;
};

function UserReadingJournalsPage() {
  const { book, journals, user } = usePage<BookJournalShowProps>().props;
  const currentUserId = useCurrentUserId();

  return (
    <BookLayout>
      <Container variant="layout" size="md" className="gap-4">
        <div className="flex flex-row justify-between items-center">
          <UserByline user={user} byline="Reading Journal By" />
          {currentUserId === user.id ? (
            <OwnerReadingJournalControls book={book} journals={journals} />
          ) : (
            false
          )}
        </div>
        {journals.length === 0 ? (
          <Callout variant="secondary" className="mt-4">
            <p>No journal entries yet.</p>
          </Callout>
        ) : (
          <ReadingJournals journals={journals} book={book} user={user} isOwner={currentUserId === user.id} />
        )}
      </Container>
    </BookLayout>
  );
}

UserReadingJournalsPage.layout = DefaultLayoutWrapper;
export default UserReadingJournalsPage;